import * as actionTypes from "./actionTypes";
import { reportingServices } from "../services/reporting.services";

export const getCorzapReports = (success, error) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_LOADING_DEFAULT_REPORTS,
    payload: true,
  });
  reportingServices
    .getCorzapReports()
    .then((response) => {
      if (
        response.data.responseCode === "SUCCESS" ||
        response.data.responseCode === "LICENSE_WARNING"
      ) {
        dispatch({
          type: actionTypes.LIST_CORZAP_REPORTS,
          payload: response.data,
        });
      } else if (response.data.responseCode === "VALIDATION_ERROR") {
        dispatch({
          type: actionTypes.LIST_CORZAP_REPORTS_ERROR,
          payload: null,
        });
        error(response.data.message || "Something went wrong");
      }
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST_CORZAP_REPORTS_ERROR,
        payload: error,
      });
      error("Something went wrong, couldn't fetch reports");
    })
    .finally(() => {
      dispatch({
        type: actionTypes.SET_LOADING_DEFAULT_REPORTS,
        payload: false,
      });
    });
};

export const getCustomReports = (userId, success, error) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_LOADING_REPORTS,
    payload: true,
  });
  reportingServices
    .getCustomReports(userId)
    .then((response) => {
      if (
        response.data.responseCode === "SUCCESS" ||
        response.data.responseCode === "LICENSE_WARNING"
      ) {
        dispatch({
          type: actionTypes.LIST_CUSTOM_REPORTS,
          payload: response.data,
        });
      } else if (response.data.responseCode === "VALIDATION_ERROR") {
        dispatch({
          type: actionTypes.LIST_CUSTOM_REPORTS_ERROR,
          payload: null,
        });
        error(response.data.message || "Something went wrong");
      }
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST_CUSTOM_REPORTS_ERROR,
        payload: error,
      });
      error("Something went wrong, couldn't fetch reports");
    })
    .finally(() => {
      dispatch({
        type: actionTypes.SET_LOADING_REPORTS,
        payload: false,
      });
    });
};

export const saveCustomReport =
  (
    userId,
    reportName,
    data,
    filters,
    success,
    error,
    generateRandomString = true
  ) =>
  (dispatch) => {
    reportingServices
      .saveCustomReport(userId, reportName, data, generateRandomString)
      .then(() => {
        dispatch(getCustomReports(userId, success, error));
        if (filters)
          dispatch(getReportData(userId, reportName, filters, success, error));
        success("Report saved successfully");
      })
      .catch((err) => {
        console.log(err);
        error("Something went wrong");
      });
  };

export const setLoadingReportData = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_LOADING_REPORT_DATA,
    payload,
  });
};

export const getReportData =
  (userId, reportName, filters, success, error) => (dispatch) => {
    dispatch(setLoadingReportData(true));
    reportingServices
      .getReportData(userId, reportName, filters)
      .then((res) => {
        if (
          res.data.responseCode === "SUCCESS" ||
          res.data.responseCode === "LICENSE_WARNING"
        ) {
          dispatch({
            type: actionTypes.GET_REPORT_DATA,
            payload: res.data,
          });
        } else if (res.data.responseCode === "VALIDATION_ERROR") {
          dispatch({
            type: actionTypes.GET_REPORT_DATA_ERROR,
            payload: null,
          });
          error(res.data.message || "Something went wrong");
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: actionTypes.GET_REPORT_DATA_ERROR,
          payload: err,
        });
        error("Something went wrong");
      })
      .finally(() => {
        dispatch(setLoadingReportData(false));
      });
  };

export const changeSearchCriteria = (payload) => (dispatch) => {
  dispatch({
    type: actionTypes.CHANGE_SEARCH_CRITERIA,
    payload,
  });
};

export const resetSearchCriteria = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_SEARCH_CRITERIA,
  });
};

export const updateCustomReport =
  (userId, reportName, data, filters, success, error) => (dispatch) => {
    reportingServices
      .updateCustomReport(userId, reportName, data)
      .then(() => {
        dispatch(getCustomReports(userId, success, error));
        if (filters)
          dispatch(getReportData(userId, reportName, filters, success, error));
        success("Report updated successfully");
      })
      .catch((err) => {
        console.log(err);
        error("Something went wrong");
      });
  };

export const deleteCustomReport =
  (userId, reportName, success, error) => (dispatch) => {
    reportingServices
      .deleteCustomReport(userId, reportName)
      .then(() => {
        dispatch(getCustomReports(userId, success, error));
        // success("Report deleted successfully");
      })
      .catch((err) => {
        console.log(err);
        error("Something went wrong");
      });
  };

export const getInitialReportData = (filters, success, error) => (dispatch) => {
  dispatch(setLoadingReportData(true));
  reportingServices
    .getInitialReportData(filters)
    .then((res) => {
      if (
        res.data.responseCode === "SUCCESS" ||
        res.data.responseCode === "LICENSE_WARNING"
      ) {
        dispatch({
          type: actionTypes.GET_REPORT_DATA,
          payload: res.data,
        });
      } else if (res.data.responseCode === "VALIDATION_ERROR") {
        dispatch({
          type: actionTypes.GET_REPORT_DATA_ERROR,
          payload: null,
        });
        error(res.data.message || "Something went wrong");
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: actionTypes.GET_REPORT_DATA_ERROR,
        payload: err,
      });
      error("Something went wrong");
    })
    .finally(() => {
      dispatch(setLoadingReportData(false));
    });
};

export const clearReportData = () => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_REPORT_DATA,
  });
};
